<template>
  <v-overlay color="primary" opacity="1" style="z-index: 1000">
    <v-card color="white" elevation="30" light width="550">
      <v-card-text class="pa-5">
        <stack-assist-logo />
        <v-form @submit.prevent="handleForm">
          <v-text-field
            v-model="form_data.password"
            label="New password"
            :type="show_password ? 'text' : 'password'"
            :error-messages="formErrors.password"
            :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
            class="required"
            @change="formErrors.password = null"
            @click:append="show_password = !show_password"
          />
          <v-text-field
            v-model="form_data.password_confirmation"
            label="Confirm new password"
            :type="show_password_confirmation ? 'text' : 'password'"
            :error-messages="formErrors.password_confirmation"
            :append-icon="
              show_password_confirmation ? 'mdi-eye' : 'mdi-eye-off'
            "
            class="required"
            @change="formErrors.password_confirmation = null"
            @click:append="
              show_password_confirmation = !show_password_confirmation
            "
          />
          <v-card-actions class="mt-5 pa-0">
            <v-btn type="submit" color="primary">
              <v-icon class="mr-2"> mdi-lock-reset</v-icon>
              Reset password
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-overlay>
</template>

<script>
import api from '@/api'
import { translate_messages } from '@/filter'
import { showSnackbar, logout } from '@/actions'
import StackAssistLogo from '@/components/StackAssistLogo.vue'
import { useUserStore } from '@/stores/UserStore'

export default {
  components: { StackAssistLogo },
  data() {
    return {
      form_data: {
        token: this.$route.params.token,
        email: this.$route.params.email,
        password: '',
        password_confirmation: '',
      },
      formErrors: {},
      show_password: false,
      show_password_confirmation: false,
    }
  },

  mounted() {
    const userStore = useUserStore()

    if (userStore.isLoggedIn()) {
      logout()
    }
  },

  methods: {
    handleForm() {
      if (this.form_data.password !== this.form_data.password_confirmation) {
        this.formErrors = {
          password_confirmation: 'Passwords do not match',
        }
      } else {
        api
          .post('reset-password', this.form_data, { _auth: true })
          .then(() => {
            this.$router.push({ name: 'login' })
            showSnackbar(
              'Password was reset',
              'Log in with your new password.',
              'success'
            )
          })
          .catch((err) => {
            if (err.response && err.response.data && err.response.data.errors) {
              this.formErrors = translate_messages(err.response.data.errors)

              // Merge generic errors into the password field so that they will be displayed in the form.
              if (this.formErrors.email && !this.formErrors.password) {
                this.formErrors.password = this.formErrors.email
              }

              if (this.formErrors.password) {
                this.formErrors.password_confirmation = this.formErrors.password
              }
            }
            showSnackbar(
              'Password reset failed',
              'Please check the form for errors.',
              'error'
            )
          })
      }
    },
  },
}
</script>
